<template>
  <div class="battery-slide relative flex" v-if="RemainFlightTime != 0">
    <div style="background: #535759" class="w-full"></div>
    <div class="capacity-percent" :style="{ width: Battery + '%' }"></div>
    <div class="return-home" :style="{ width: BatteryRemainRTH + '%' }"></div>
    <div class="landing" :style="{ width: BatteryLandingPower + '%' }"></div>
    <div
      class="white-point"
      :style="{ left: 'calc(' + Battery + '% - 6px)' }"
    ></div>
    <div class="battery" :style="{ left: 'calc(' + Battery + '% - 21px)' }">
      <span>
        {{ Math.floor(RemainFlightTime / 60) }}
      </span>
      <div class="TimerClockAnimation"> : </div>
      <span>
        {{ 10 > RemainFlightTime % 60 ? "0" : "" }}{{ RemainFlightTime % 60 }}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    config: Object,
  },
  computed: {
    Battery() {
      if (this.$root.query.hasOwnProperty("DebugFakeBattery")) {
        return 80;
      }

      return this.config?.drone?.status?.battery?.capacity_percent != undefined
        ? this.config.drone.status.battery.capacity_percent
        : 0;
    },

    RemainFlightTime() {
      if (this.$root.query.hasOwnProperty("DebugFakeBattery")) {
        return 50;
      }

      return this.config?.drone?.status?.battery?.remain_flight_time !=
        undefined
        ? this.config.drone.status.battery.remain_flight_time
        : 0;
    },
    BatteryRemainRTH() {
      if (this.$root.query.hasOwnProperty("DebugFakeBattery")) {
        return 30;
      }

      return this.config?.drone?.status?.battery?.return_home_power != undefined
        ? this.config.drone.status.battery.return_home_power
        : 0;
    },

    BatteryLandingPower() {
      if (this.$root.query.hasOwnProperty("DebugFakeBattery")) {
        return 10;
      }

      return this.config?.drone?.status?.battery?.landing_power != undefined
        ? this.config.drone.status.battery.landing_power
        : 0;
    },
  },
};
</script>

<style>
.battery-slide > div {
  min-height: 6px !important;
}
.battery-slide .battery {
  top: 21px !important;
}
</style>
